var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M0.453724 9.22736L0.969394 9.41766H1.16344C1.57619 9.41766 2.10579 8.86071 6.01136 4.63834L7.19815 3.28056L7.73955 3.8241C8.19518 4.24864 8.62616 4.70213 9.02926 5.18135C9.75077 5.87391 10.4991 6.70209 11.1702 7.44879C12.4588 8.88805 12.9241 9.39032 13.4258 9.39032H13.606L14.0573 9.2681L14.38 8.38578L14.0337 7.99233C13.2586 7.08696 12.461 6.20411 11.6344 5.34431C10.5001 4.10874 9.36482 2.92785 8.25629 1.80109L7.81781 1.43444L7.21209 0.931641L6.68248 1.36637C6.48951 1.55666 6.23221 1.8413 5.94704 2.16721C5.50963 2.68341 5.04436 3.17228 4.55442 3.63381C3.85864 4.44805 3.00741 5.29016 2.2591 6.03687C0.595236 7.72056 0.196428 8.11455 0.325077 8.75243L0.453724 9.22736Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0364197,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.60c7cc70000bcb2ccd9f1129c3274eb3.svg";
export { ForwardRef as ReactComponent };